import {is_subAdmin} from './userRoles'

export const has_screenPermission = (permissions, id, user) => {
  return is_subAdmin(user)
    ? permissions == null || Object.keys(permissions).length === 0
      ? false
      : !!permissions[id]
    : true
}
